import {push} from '../helpers/seo';

import {useSelector} from 'react-redux';

import styles from './Global.module.scss';

function Home() {
  const content = useSelector(state => state.content.value);
  const homepage = content.homepage;
  const image = homepage.image.filter(image => image.key === 'banner')[0].url;

  push({
    title:       'About',
    description: 'About Coppr',
    keywords:    'about, coppr, artists, concerts, events, shows, dates, tickets'
  });

  return (
    <div>
      <div className={styles.wysiwyg} dangerouslySetInnerHTML={{__html: homepage.content}}/>
      <img src={image} alt="CopprArt.be"/>
    </div>
  );
}

export default Home;